module.exports = __webpack_public_path__ + "img/montaza.d12634a8.svg";